import styled from 'styled-components';

export const Footer = styled.footer`
    background-color: #025939;
    padding: 1em;
    display: flex;
    align-items: center;
    margin-top: 2em;
    justify-content: center;
`;